import find from 'lodash/find'
import last from 'lodash/last'
import type { DocumentFieldErrors } from '../types/QueryInput'

/** The error raised for one field of the document, matched on the last segment of its `path`. */
export const getFieldError = (fieldErrors: DocumentFieldErrors | undefined, field: string) =>
  find(fieldErrors, (fieldError) => last(fieldError.path) === field)
